<template>
        <el-drawer :title="form.id ? '管理菜单' : '创建菜单'" :visible.sync="addMenuVisible" :before-close="closeDialog" size="400px">
            <div class="drawer-content">
                <el-form :model="form" label-position="top" ref="addMenu" :rules="rules">                 
                    <el-form-item  label="父级菜单" prop="pid">
                        <el-select v-model="form.pid" placeholder="请选择" style="width: 100%;" size="medium">
                            <el-option v-for="i in parentMenuOptions" :key="i.id" :label="i.title" :value="i.id"></el-option>
                        </el-select>
                    </el-form-item>                         
                    <el-form-item label="名称" prop="title">
                        <el-input v-model="form.title" autocomplete="off" maxlength="40" placeholder="请输入菜单名称" size="medium"></el-input>
                    </el-form-item>                                   
                    <el-form-item label="所属终端" prop="terminals" class="terminal">
                        <el-checkbox-group v-model="form.terminals" size="medium">
                            <el-checkbox :label="1" name="terminals">WEB</el-checkbox>
                            <el-checkbox :label="2" name="terminals">WAP</el-checkbox>
                            <el-checkbox :label="3" name="terminals">APP乐迷版</el-checkbox>
                            <el-checkbox :label="4" name="terminals">经营平台</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <el-select v-model="form.status" placeholder="请选择" style="width: 100%;" size="medium">
                            <el-option label="展示" :value="1"></el-option>
                            <el-option label="隐藏" :value="-1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="sort" class="has-tips">
                        <template slot="label">
                            <span>序号</span>
                            <div class="tips">
                                <el-tooltip class="item" effect="dark" content="当前菜单有所属父级菜单时，序号才有意义。前端按序号从低到高的顺序进行展示" placement="top-start">
                                    <span>当前菜单有所属父级菜单时，序号才有意义。前端按序号从低到高的顺序进行展示</span>
                                </el-tooltip>
                            </div>
                        </template>
                        <el-input v-model="form.sort" autocomplete="off" size="medium"></el-input>
                        <div class="bottom-tips" v-if="showChildNum != null">
                            当前父级菜单下共展示了 {{ showChildNum }} 个子级菜单
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div class="drawer-footer">
                <el-button @click="closeDialog">取 消</el-button>
                <el-button type="primary" @click="submitForm" :loading="submitLoading">确 定</el-button>
            </div>
        </el-drawer>
</template>

<script>
const defaultData = {
    status: 1, // 状态
    terminals: [], 
    //1:WEB 2:WAP 3:APP 4:经营平台 5:WEB WAP 6:WEB APP 7:WEB 经营平台 8:WAP APP 9:WAP 经营平台 10: APP 经营平台 11:WEB WAP APP 12:WEB WAP 经营平台 13:WEB APP 经营平台 14:WAP APP 经营平台 15: WEB WAP APP 经营平台
    title: '', // 菜单标题
    sort: 1, // 排序
    pid: 0 // 父级菜单id
}
export default {
    props: {
        // addMenuVisible: {
        //     type: Boolean,
        //     default: false
        // },
        // detailData: {
        //     type: Object,
        //     default: null
        // }
    },
    data(){
        const checkNum = (rule, value, callback) => {
            const reg = /^[1-9][0-9]{0,7}$/
            if (value !== '') {
                if(reg.test(value)){
                    callback();                    
                }else{
                    return callback(new Error('只能填写大于1-99999999的正整数'));
                }                
            }            
        };
        return {
            form: {...defaultData},
            parentMenuOptions: [],
            showChildNum: null,
            submitLoading: false,
            terminalMap: new Map([
                ['1', 1],
                ['2', 2],
                ['3', 3],
                ['4', 4],
                ['12', 5],
                ['13', 6],
                ['14', 7],
                ['23', 8],
                ['24', 9],
                ['34', 10],
                ['123', 11],
                ['124', 12],
                ['134', 13],
                ['234', 14],
                ['1234', 15]
            ]),
            rules: {
                pid: [
                    { required: true, message: '请选择父级菜单', trigger: 'change' }
                ],
                title:  [
                    { required: true, message: '请输入菜单名称', trigger: 'blur' }
                ],
                terminals: [
                    { type: 'array', required: true, message: '请至少选择一个所属终端', trigger: 'change' }
                ],
                sort: [
                    { required: true, message: '请输入序号', trigger: 'blur' },
                    { validator: checkNum, trigger: 'blur' }
                ],
                status: [
                    { required: true, message: '请选择状态', trigger: 'change' }
                ]
            },
            addMenuVisible: false
        }
    },
    created(){
        this.getAllShowParentMenu();
    },
    // watch: {
    //     'form.pid'(n){
    //         if(!n) return;
    //         this.getShowMenuNum(n);
    //     },
    //     detailData(n){
    //         if(n) {                
    //             for(let [key, value] of this.terminalMap){
    //                 if(value === n.terminal){
    //                     n.terminals = key.split('').map(Number);
    //                 }
    //             }
    //             n.sort = n.sort || 1;
    //             this.form = {...n};
    //         }else{
    //             this.form = {...defaultData};
    //         }
    //     }
    // },
    methods: {
        show(data){
            if( data ){
                const n = {...data};
                for(let [key, value] of this.terminalMap){
                    if(value === data.terminal){
                        n.terminals = key.split('').map(Number);
                    }
                }
                n.sort = n.sort || 1;
                this.form = {...n};
                if( this.form.pid ){
                    this.getShowMenuNum(this.form.pid);
                }
            }
            
            this.addMenuVisible = true;
        },
        submitForm(){
            this.$refs['addMenu'].validate((valid) => {
                if (valid) {
                    this.submitLoading = true;
                    const data = {...this.form};
                    data.terminal = this.terminalMap.get(this.form.terminals.sort().join('')) ;
                    const url = data.id ? '/help/menu/update' : "/help/menu/create";
                    this.$request({
                        url,
                        method: "POST",
                        data
                    }).then(res=>{
                        const {state, msg} = res.data;
                        if (state == 1) {
                            this.$message.success( data.id ? '更新成功' : '创建成功');
                            this.closeDialog();
                            this.$parent.getDataList();
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    }).catch(() => {
                        this.$message.error("请求错误");
                    }).finally(()=>{
                        this.submitLoading = false;
                    })
                }
            });
        },
        // 查询所有展示状态的一级菜单
        getAllShowParentMenu(){
            this.$request({
                url: "/help/menu/getFirstMenus",
                method: "POST"
            }).then((res) => {
                const { state, msg, result } = res.data;
                if (state == 1 && result) {
                    this.parentMenuOptions = [{id: 0, title: '无'}].concat(result);
                } else {
                    this.$message.error(msg || "请求失败");
                }
            })
            .catch(() => {
                this.$message.error("请求错误");
            })
            .finally(() => {
                this.listLoading = false;
            });
        },
        // 父级菜单下有多少展示状态的子菜单
        getShowMenuNum(pId){
            this.$request({
                url: "/help/menu/countChildMenu",
                method: "POST",
                params: {pId},
            }).then(res=>{
                const {state, msg, result} = res.data;
                if (state == 1) {
                    this.showChildNum = result || 0;
                } else {
                    this.$message.error(msg || "请求失败");
                }
            }).catch(() => {
                this.$message.error("请求错误");
            })
        },
        closeDialog(){
            // this.$emit('update:addMenuVisible', false); 
            this.form = {...defaultData};         
            this.showChildNum = null;
            this.$nextTick(()=>{
                this.$refs['addMenu'].clearValidate();     
            })  
            this.addMenuVisible = false;            
        }
    }
}
</script>

<style lang="scss" scoped>
.terminal{
    ::v-deep .el-form-item__content{
        line-height: 34px;
    }
}
.has-tips {
    ::v-deep .el-form-item__label{
        width: 100%;
        display: flex;
        align-items: center;

        & > * {
            flex: 0 0 auto;
        }
        .tips{
            flex: 1 1 auto;
            margin-left: 10px;
            font-size: 12px;
            overflow: hidden;
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }    
}
</style>